@if (buttonConfig; as btn) {
    <button
        class="mb-3 mt-3 !rounded-full w-full"
        color="primary"
        type="button"
        mat-raised-button
        (click)="btn.action()"
    >
        <span>{{ btn.label }}</span>
    </button>
}
